import coerceToRecord from '../helpers/coerceToRecord';
import eventMatchesToolNames from '../helpers/eventMatchesToolNames';
import getStringValue from '../helpers/getStringValue';
import type {
    BuildNavigateAwayOnSkillDeleteSubscriptionParams,
    ChatEffectSubscription,
} from '../types';

const DELETE_SKILL_TOOL_NAMES = ['delete_skill'];

const buildNavigateAwayOnSkillDeleteSubscription = (
    _params: BuildNavigateAwayOnSkillDeleteSubscriptionParams
): ChatEffectSubscription => {
    return {
        id: 'navigate-away-on-skill-delete',
        routePattern: '/agents/:agentId/skills/:skillId/file/:fileId',
        eventType: 'TOOL_CALL_RESULT',
        filter: ({ event, matchParams }) => {
            if (!eventMatchesToolNames({ event, toolNames: DELETE_SKILL_TOOL_NAMES })) {
                return false;
            }

            const result = coerceToRecord({ value: event.result });
            const args = coerceToRecord({ value: event.args });
            const deletedSkillId = getStringValue({ value: args.skillId });
            const wasSuccessfulDelete = result.success === true;
            return wasSuccessfulDelete && deletedSkillId === matchParams.skillId;
        },
        action: ({ queryClient, matchParams, navigate }) => {
            queryClient.invalidateQueries(['skills']);
            queryClient.invalidateQueries(['skills-search']);
            queryClient.invalidateQueries(['skill', matchParams.skillId]);
            navigate(`/agents/${matchParams.agentId}/skills`);
        },
    };
};

export default buildNavigateAwayOnSkillDeleteSubscription;
